import React from "react";
import SectionContainer from '../containers/section-container';
import TabsElement from '../tabs/tabs';
import Heading2Paragraph from '../titles/heading2-paragraph';

export default class FeatureTabs extends React.Component {
    render() {
        return (
            <SectionContainer>
                    <Heading2Paragraph content={ this.props.content } />
                    <TabsElement tabData={ this.props.tabData }/>
            </SectionContainer>              
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/feature-tabs.js